import {ElementUtil} from '../../utils/elementUtil.js';

export const MIGRATE_UNITS_STEP = 'Migrate Units';

export const MIGRATION_BOOKEND_STEPS = [
	'Initializing',
	'Completing Migration',
	'Initializing Finalize',
	'Completing Finalize'
];

export const DEFAULT_MIGRATION_STEP_OPTIONS = {
	initialSteps: [
		'Initializing',
		'Validate Environment',
		'Migrate Billing Setup',
		'Migrate Billing History',
		'Migrate Users',
		'Migrate Units',
		'Migrate Company Config',
		'Migrate Operational Data',
		'Migrate Integrations',
		'Migrate Reports',
		'Cleanup Inactive Tractors',
		'Completing Migration'
	],
	finalizeSteps: [
		'Initializing Finalize',
		'Deactivate V6 Data Feeds',
		'Wait For Data Feeds Idle',
		'Sync Integration Pull Dates',
		'Activate Pending Integrations',
		'Set V6 Do Not Bill',
		'Cleanup Inactive Tractors',
		'Lock V6 Data Months',
		'Completing Finalize'
	],
	unitEntityTypes: ['DRIVER', 'TRACTOR', 'TRAILER']
};

export function selectableMigrationSteps(steps) {
	return (steps || []).filter(function(step) {
		return MIGRATION_BOOKEND_STEPS.indexOf(step) < 0;
	});
}

export function stepsForMigrationPhase(stepOptions, migrationPhase) {
	var options = stepOptions || DEFAULT_MIGRATION_STEP_OPTIONS;
	if (migrationPhase === 'FINALIZATION') {
		return selectableMigrationSteps(options.finalizeSteps);
	}
	return selectableMigrationSteps(options.initialSteps);
}

export async function loadMigrationStepOptions(migrationService) {
	try {
		var response = await migrationService.getMigrationStepOptions();
		return response.data || response || DEFAULT_MIGRATION_STEP_OPTIONS;
	} catch (ignored) {
		return DEFAULT_MIGRATION_STEP_OPTIONS;
	}
}

/**
 * Optional run-only step + unit entity filters for re-sync / retry forms.
 */
export function buildMigrationRunStepFields(options) {
	options = options || {};
	var migrationPhase = options.migrationPhase || 'INITIAL';
	var defaultStep = options.defaultStep || null;
	var stepCombo;
	var unitEntityPanel;
	var unitDriverCheckbox;
	var unitTractorCheckbox;
	var unitTrailerCheckbox;

	function updateUnitEntityVisibility(stepName) {
		if (!unitEntityPanel) {
			return;
		}
		unitEntityPanel.style.display = stepName === MIGRATE_UNITS_STEP ? 'block' : 'none';
	}

	var fields = [
		{
			tag: 'vaadin-combo-box',
			name: 'runOnlyStep',
			label: 'Run only step (optional)',
			placeholder: 'Full migration flow',
			'allow-custom-value': false,
			clearButtonVisible: true,
			postinit: function(element) {
				stepCombo = element;
				if (defaultStep) {
					element.value = defaultStep;
					updateUnitEntityVisibility(defaultStep);
				}
				element.addEventListener('change', function(event) {
					updateUnitEntityVisibility(event.target.value || null);
				});
			}
		},
		{
			tag: 'div',
			style: 'display: none; margin-top: 4px;',
			postinit: function(element) {
				unitEntityPanel = element;
			},
			children: [
				{
					tag: 'div',
					style: 'margin-bottom: 6px; font-weight: 600;',
					innerHTML: 'Unit entity types'
				},
				{
					tag: 'vaadin-checkbox',
					name: 'unitDriver',
					label: 'Drivers',
					checked: true,
					postinit: function(element) {
						unitDriverCheckbox = element;
					}
				},
				{
					tag: 'vaadin-checkbox',
					name: 'unitTractor',
					label: 'Tractors',
					checked: true,
					postinit: function(element) {
						unitTractorCheckbox = element;
					}
				},
				{
					tag: 'vaadin-checkbox',
					name: 'unitTrailer',
					label: 'Trailers',
					checked: true,
					postinit: function(element) {
						unitTrailerCheckbox = element;
					}
				}
			]
		}
	];

	return {
		fields: fields,
		bindStepOptions: function(stepOptions) {
			if (!stepCombo) {
				return;
			}
			stepCombo.items = stepsForMigrationPhase(stepOptions, migrationPhase);
			if (defaultStep && stepCombo.items.indexOf(defaultStep) >= 0) {
				stepCombo.value = defaultStep;
				updateUnitEntityVisibility(defaultStep);
			}
		},
		collectRunStepRequestData: function() {
			var data = {};
			var stepName = stepCombo ? (stepCombo.value || null) : null;
			if (stepName) {
				data.runOnlyStep = stepName;
			}
			if (stepName === MIGRATE_UNITS_STEP) {
				var unitEntityTypes = [];
				if (unitDriverCheckbox && unitDriverCheckbox.checked) {
					unitEntityTypes.push('DRIVER');
				}
				if (unitTractorCheckbox && unitTractorCheckbox.checked) {
					unitEntityTypes.push('TRACTOR');
				}
				if (unitTrailerCheckbox && unitTrailerCheckbox.checked) {
					unitEntityTypes.push('TRAILER');
				}
				if (unitEntityTypes.length > 0 && unitEntityTypes.length < 3) {
					data.unitEntityTypes = unitEntityTypes;
				}
			}
			return data;
		}
	};
}

export function appendMigrationRunStepSummaryLines(record, lines) {
	if (!record) {
		return lines;
	}
	if (record.runOnlyStep) {
		lines.push({label: 'Run only step', value: record.runOnlyStep});
	}
	if (record.unitEntityTypes) {
		lines.push({label: 'Unit entity types', value: record.unitEntityTypes});
	}
	return lines;
}
